export default "__VITE_ASSET__Bn554VGf__"